import {Component, OnInit} from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-drawer-siple-spec',
  templateUrl: './drawer-siple-spec.component.html',
  styleUrls: ['./drawer-siple-spec.component.scss']
})
export class DrawerSipleSpecComponent implements OnInit {

  constructor(public  coef: CoefService) {
  }

  ngOnInit() {
  }

}
